import React from "react";

const FeatureCard = ({ title, description }) => {
  return (
    <div className="bg-[#150c1c] rounded-lg p-10 flex flex-col h-[280px] w-full border-[1px] border-[#4B006E] hover:-translate-y-[8px] hover:scale-[1.02] hover:shadow-[0_0_15px_rgba(138,0,212,0.3)] transition-all duration-300">
      <h3 className="font-display font-bold text-3xl text-[#8A00D4] mb-4">
        {title}
      </h3>
      <p className="font-sans font-normal text-lg text-lightText leading-relaxed">
        {description}
      </p>
    </div>
  );
};

export default FeatureCard;
